"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { ChartLine, Briefcase, Landmark, ChevronRight } from "lucide-react";
const services = [{
  title: "Satellite Imagery Acquisition",
  description: "High-resolution orbital data capture providing precise spatial intelligence for global monitoring and strategic decision-making across all sectors.",
  icon: ChartLine,
  link: "/ServicesPage"
}, {
  title: "Photogrammetric Analysis",
  description: "Advanced processing of aerial and satellite imagery to generate accurate 3D models, topographic maps, and detailed spatial measurements.",
  icon: Briefcase,
  link: "/ServicesPage"
}, {
  title: "Geodetic Surveying",
  description: "Precision engineering services utilizing ground-based stations and orbital positioning to establish highly accurate geographic reference frames.",
  icon: Landmark,
  link: "/ServicesPage"
}];
export default function OurCoreServices() {
  return;
}